import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const subscribeEventsFileCardTemplate = htmlE`
  <div id="${"uid"}" class="subscribe-events-file-card p-2">
    <div class="is-flex is-justify-content-space-between">
      ${({ path }) =>
        `
        <b title="${utils.textEncode(
          utils.sanitizePure(path)
        )}" class="text-sm whitespace-nowrap is-clipped is-ellipsis is-user-select-all mr-5">
          ${utils.textEncode(path)}
        </b>
        `}

        <div class="action-button-wrapper is-flex is-align-items-center gap-3">
            ${({ editText }) => {
              if (editText) {
                return `
                    <button
                        tabindex="0"
                        type="button"
                        class="primary-button is-bg-none p-0 edit-button"
                    >
                        <i class="icon-edit text-sm mr-2 text-accentMain"></i>
                        <span class="text-sm" data-i18n-key="edit">${editText}</span>
                    </button>`;
              }
            }}

            ${({ deleteText }) => {
              if (deleteText) {
                return `
                        <button
                            tabindex="0"
                            type="button"
                            class="primary-button is-bg-none p-0 ml-2 delete-button"
                        >
                            <i class="icon-trash mr-2 text-error text-sm"></i>
                            <span class="text-sm" data-i18n-key="Delete">${deleteText}</span>
                        </button>`;
              }
            }}

      </div>
    </div>
    <div class="permissions-allowed is-flex">
    </div>
  </div>`;

export const subscribedEventsWrapperTemplate = htmlE`
  <div id="subscribe-events-wrapper" class="h-full w-full"></div>
`;

export const permissionTextTemplate = htmlE`
  ${({ permission, permissionText }) => {
    return `
      <div class="permission text-xs whitespace-nowrap text-secondaryMain has-text-weight-semibold">
        <span data-i18n-key="${permissionText}">${permission}</span>
      </div>`;
  }}
`;
